import React from "react";
import { Button, Modal } from "react-bootstrap";


const NewModal = ({ show, setShow, children, ExtraButton, onShow, title, onHide }) => {
  return (
    <Modal
      size="lg"
      show={show}
      onHide={() => {setShow(false); typeof onHide !== "undefined" && onHide()} }
      dialogClassName="modal-90w"
      contentClassName="modal-modern-content"
      onShow={() => {(onShow) && onShow()}}
    >
      <style>{`
        .modal-modern-content { border-radius: 12px !important; overflow: hidden; border: none !important; box-shadow: 0 8px 32px rgba(0,0,0,0.18); background: transparent !important; }
        .modal-90w { max-width: 90vw !important; width: 90vw !important; }
      `}</style>
      <Modal.Header closeButton={true} style={{
        background: "linear-gradient(135deg, #1a73e8 0%, #0d47a1 100%)",
        color: "#fff",
        border: "none",
        borderRadius: "12px 12px 0 0",
        padding: "20px 24px",
      }}>
        <Modal.Title id="Billview" style={{ fontWeight: 700, fontSize: "1.1rem" }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: "24px", background: "#fafafa" }}>{children}</Modal.Body>
      <Modal.Footer style={{
        background: "#fff",
        border: "none",
        borderTop: "1px solid #f0f0f0",
        borderRadius: "0 0 12px 12px",
        padding: "14px 24px",
        gap: "8px",
      }}>
        {ExtraButton ? <ExtraButton /> : null}
        <Button variant="outline-secondary" style={{ borderRadius: "8px", fontWeight: 500, fontSize: "0.88rem" }} onClick={() => setShow(false)}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NewModal;
